import React, { Component } from "react";
import {
  IoMdTime,
  IoIosCalendar,
  IoMdCart,
  IoIosPaper,
  IoMdSend,
} from "react-icons/io";
import { Row, Col } from "antd";
import { IoPersonOutline } from "react-icons/io5";

import { ParsedDate } from "../../function/ParseDate";
// import axiosGlobal from "../../axios-global";

import "../../assets/css/publish.css";
import "../../assets/css/modal.css";

export default class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // v: {},
    };
  }
  componentDidMount() {}
  // fetchDataPsikogram = (v) => {
  //   const params = {
  //     participantId: v.participantId,
  //   };

  //   try {
  //     axiosGlobal().then((axios) => {
  //       axios.post("/psikogram/pdf", params).then((res) => {
  //         if (!res.data.data.length) {
  //           return false;
  //         } else {
  //           return true;
  //         }
  //       });
  //     });
  //   } catch (err) {
  //     console.log(err);
  //     return false;
  //   }
  // }

  actionStatement = (data) => {
    // if(data === "free-of-charge") {
    //   return "Mulai";
    // } else if (data === "in-arrear") {
    //   return "Mulai";
    // }
    console.log(data.status_code);
    if (data.status_code === "01") {
      return (
        <p className="text btn-active send myapp">
          <span style={{ color: "white" }}>_</span>Mulai
          <span style={{ color: "white" }}>_</span>
        </p>
      );
    } else if (data.status_code === "02") {
      return <p className="text btn-active send myapp">Progress</p>;
    } else {
      return <p className="text btn-active send myapp">Selesai</p>;
    }
  };

  render() {
    return (
      <>
        {/* {this.props.data.map((v, i) => ( */}
        {/* <div className="card-publish my-app" key={i}> */}
        <div className="card-inner">
          <div className="card-text">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "space-between",
                justifyContent: "flex-end",
                alignSelf: "baseline",
                cursor: "pointer",
                height: "12.5rem",
              }}
            >
              <h4>{this.props.v.publish_name}</h4>

              <h5>{this.props.v.inst_name}</h5>
              <div className="row-icon">
                <div style={{ display: "flex", marginLeft: "0" }}>
                  <IoPersonOutline className="icon" />
                  <p>{this.props.v.participant_count}</p>
                </div>
                <div
                  style={{
                    backgroundColor: "lightgrey",
                    border: "0.5px solid lightgrey",
                    height: "1rem",
                  }}
                ></div>
                <div
                  style={{
                    display: "flex",
                    marginRight: "0",
                  }}
                >
                  <IoMdTime className="icon" />
                  <p>{ParsedDate(this.props.v.created_at)}</p>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  paddingBottom: "3rem",
                }}
              >
                <IoIosCalendar className="icon" />
                <p>
                  {ParsedDate(this.props.v.started_at)} -
                  {" " + ParsedDate(this.props.v.finished_at)}
                </p>
              </div>
            </div>
          </div>

          {/*  */}
          {/*  */}
          <div
            style={{
              position: "absolute",
              bottom: "12px",
              left: "0px",
              paddingTop: "0.5rem",
              display: "flex",
              flexDirection: "row",
              // justifyContent: "space-evenly",
              alignItems: "center",
            }}
          >
            <div
              style={{
                // backgroundColor: "black",
                // width: "15rem",
                // width: "275px",
                // backgroundColor: "green",
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-evenly",
                alignContent: "center",
                flexDirection: "row",
              }}
              className="button-icons myapp"
            >
              {/* <div className="button-icons myapp"> */}
              {/* !this.props.v.report_example */}
              {/* ada psikogram? */}
              {/* !this.fetchDataPsikogram(this.props.v) */}
              {/* && !this.props.v.is_paid */}
              {this.props.v.show_report !== "no_show_report" &&
                this.props.v.payment_type === "in-arrear" && (
                  // <Col span={8} style={{backgroundColor: "green"}}>
                  <div
                    style={{
                      display: "flex",
                      flex: "1 1 auto",
                      flexDirection: "column",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    // onClick={() => this.props.onPsikogram(this.props.v)}
                    onClick={() =>
                      !this.props.v.is_paid && this.props.v.status_code === "03"
                        ? this.props.onConfirmationPdf(this.props.v)
                        : this.props.onPsikogram(this.props.v)
                    }
                  >
                    {/* <div
                    style={{
                      display: "flex",
                      flex: "1 1 auto",
                      flexDirection: "column",
                      aligsdnItems: "center",
                      justifyContent: "center",
                      backgroundColor: "grey",
                      // marginLeft: "1rem", // "-0.2"
                      cursor: "pointer",
                    }}
                    onClick={() => this.props.onPsikogram(this.props.v)}
                  > */}
                    {/* onClick={() => this.psikogram(this.props.v)} */}
                    <IoIosPaper
                      // onClick={() => this.props.onPsikogram(this.props.v)}
                      //  paper
                      // style={{ display: "flex", margin: "auto" }}
                      className="btn-modal myapp"
                    />
                    <p className="text btn-active">Psikogram</p>
                    {/* </div> */}
                  </div>
                  // && this.props.v.is_report
                )}
              {this.props.v.show_report !== "no_show_report" &&
                this.props.v.payment_type !== "in-arrear" && (
                  <div
                    style={{
                      display: "flex",
                      flex: "1 1 auto",
                      flexDirection: "column",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => this.props.onPsikogram(this.props.v)}
                  >
                    {/* <div
                    style={{
                      display: "flex",
                      flex: "1 1 auto",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "grey",
                      // marginLeft: "1rem", // "-0.2"
                      cursor: "pointer",
                    }}
                    onClick={() => this.props.onPsikogram(this.props.v)}
                  > */}
                    {/* onClick={() => this.psikogram(this.props.v)} */}
                    <IoIosPaper
                      // onClick={() => this.props.onPsikogram(this.props.v)}
                      //  paper
                      // style={{ display: "flex", margin: "auto" }}
                      className="btn-modal myapp"
                    />
                    <p className="text btn-active">Psikogram</p>
                    {/* </div> */}
                  </div>
                )}
              {/* <div className="gap-icon cart"></div> */}
              {/* this.props.v.payment_type !== "free-of-charge" */}
              {false && (
                // <Col span={8}>
                <div
                  style={{
                    display: "flex",
                    flex: "1 1 auto",
                    flexDirection: "column",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  {/* <div
                  style={{
                    display: "flex",
                    flex: "1 1 auto",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "red",
                    cursor: "pointer",
                  }}
                  onClick={() => this.openReportModal(this.props.v)}
                > */}
                  <IoMdCart
                    // onClick={() => this.openReportModal(this.props.v)}
                    //  video-add
                    className="btn-modal myapp"
                  />
                  <p
                    // style={{
                    //   marginLeft: "1.4rem",
                    // }}
                    className="text btn-active"
                  >
                    Pembayaran
                  </p>
                </div>
                // </div>
              )}
              {/* <div className="gap-icon start"></div> */}
              {this.props.v.payment_type === "free-of-charge" ||
              this.props.v.payment_type === "in-arrear" ? (
                <div
                  style={{
                    display: "flex",
                    flex: "1 1 auto",
                    flexDirection: "column",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => this.props.onStart(this.props.v)}
                >
                  <IoMdSend
                    //  video-add
                    className="btn-modal myapp"
                    // style={{
                    //   color: "lightsteelblue",
                    //   cursor: "not-allowed",
                    // }}
                  />
                  {/* <p
                    // style={{
                    //   marginLeft: "1.4rem",
                    // }}
                    // text myapp btn-inactive
                    className="text btn-active send myapp"
                  > */}
                  {/* <span style={{ color: "white" }}>_</span>Mulai
                    <span style={{ color: "white" }}>_</span> */}
                  {
                    this.actionStatement(this.props.v)
                    // === "Mulai" ? <span style={{ color: "white" }}>_</span>"Mulai"
                    // <span style={{ color: "white" }}>_</span>
                  }

                  {/* Selesai */}
                  {/* </p> */}
                </div>
              ) : (
                // <Col span={8}>
                <div
                  style={{
                    display: "flex",
                    flex: "1 1 auto",
                    flexDirection: "column",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => this.props.onStartInAdvance(this.props.v)}
                >
                  {/* <div
                  style={{
                    display: "flex",
                    flex: "1 1 auto",
                    backgroundColor: "green",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                  // this.props.v
                  onClick={() => this.props.onStart(this.props.v)}
                > */}
                  <IoMdSend
                    // onClick={() => this.props.onStart(this.props.v)}
                    //  video-add
                    className="btn-modal myapp"
                  />
                  {/* <p className="text btn-active send myapp">
                    //{this.props.v.is_paid === false &&
                      //!this.props.fetchDataPsikogram(this.props.v) ? //"Mulai" : "Progress"}
                    <span style={{ color: "white" }}>_</span>Mulai
                    <span style={{ color: "white" }}>_</span>
                    //Selesai
                  </p> */}
                  {this.actionStatement(this.props.v)}
                </div>
                // {/* </div> */}
              )}
            </div>
          </div>
          {/* </Row> */}
          {/* </div> */}
        </div>
        {/* ))} */}
      </>
    );
  }
}
